export default {
  data(){
    return {
      constraints: {},
      image_validity: {
        mime: null,
        min_width: null,
        max_width: null,
        min_height: null,
        max_height: null,
        max_kb: null,
        width_ratio: null,
        mime_types: null,
      },
    }
  },
  computed: {
    constraint() {
      if (this.constraints.hasOwnProperty(this.type)) {
        return this.constraints[this.type];
      } else {
        return {};
      }
    },
    imageIsValid() {
      return Object.values(this.image_validity).every(value => value === true);
    }
  },
  methods: {
    async validateImageFile(file) {
      const c = this.constraint;

      this.image_validity = {
        max_kb: true,
        mime_types: true,
        min_width: true,
        max_width: true,
        min_height: true,
        max_height: true,
        width_ratio: true
      };

      const sizeKB = Math.ceil(file.size / 1024);
      if (c.max_kb != null) {
        this.image_validity.max_kb = sizeKB <= c.max_kb;
      }

      const mime = (file.type || '').toLowerCase();
      if (Array.isArray(c.mime_types) && c.mime_types.length) {
        const allowed = c.mime_types.map(x => String(x).toLowerCase());
        this.image_validity.mime_types =
          allowed.includes(mime) || allowed.includes(mime.replace('image/', ''));
      }

      const meta = await this.getImageMeta(file);
      if (!meta) {
        this.image_validity.mime_types = false;
        return false;
      }

      if (c.min_width != null) this.image_validity.min_width = meta.width >= c.min_width;
      if (c.max_width != null) this.image_validity.max_width = meta.width <= c.max_width;
      if (c.min_height != null) this.image_validity.min_height = meta.height >= c.min_height;
      if (c.max_height != null) this.image_validity.max_height = meta.height <= c.max_height;

      if (c.width_ratio != null) {
        const expected = Number(c.width_ratio);
        const eps = 0.01;
        this.image_validity.width_ratio = Math.abs(meta.ratio - expected) <= eps;
      }

      return Object.values(this.image_validity).every(Boolean);
    },

    getImageMeta(file) {
      return new Promise((resolve) => {
        const url = URL.createObjectURL(file);
        const img = new Image();

        img.onload = () => {
          const width = img.naturalWidth || img.width;
          const height = img.naturalHeight || img.height;
          URL.revokeObjectURL(url);
          resolve({
            width,
            height,
            ratio: width / height
          });
        };

        img.onerror = () => {
          URL.revokeObjectURL(url);
          resolve(null);
        };

        img.src = url;
      });
    },
  }
}


// WEBPACK FOOTER //
// ./src/components/views/images/mixins/imageValidation.js